/**
 * @file: useReportProductManifestProps.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ProductManifestProps } from '@euler/app/flows/report/types';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useTaskProductManagement } from '@euler/app/flows/task/functions/products/useTaskProductManagement';
import { SaveTaskProductManifestOriginInfo } from '@euler/model/task-detail';
import { useMemo } from 'react';

export const useReportProductManifestProps = ({
  productManifest,
  origin,
}: {
  productManifest: ProductManifestProps | undefined;
  origin: SaveTaskProductManifestOriginInfo;
}) => {
  const taskContext = useTaskContext();
  const productManagement = useTaskProductManagement({
    origin,
  });

  return useMemo<ProductManifestProps | undefined>(() => {
    return (
      productManifest ??
      (taskContext != null
        ? {
            canAssociateProduct: productManagement.canAssociateProduct,
            items$: taskContext.taskManager.productManifestManager.manifest$,
            onViewDetail: productManagement.onViewProductDetail,
            onAdd: productManagement.onAddProduct,
            onRemove: item => {
              productManagement.onRemoveProduct(item.subject, item.product.id);
            },
          }
        : undefined)
    );
  }, [productManifest, productManagement, taskContext]);
};
